/* ==========================================================================
   ANAM KARA — THEME JS
   Vanilla JS + Intersection Observer + fetch. No jQuery, no cursor gimmick —
   native cursor throughout, per direction.
   ========================================================================== */

window.AK = window.AK || {};

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- music toggle: click-to-start only. Browsers block forced
     autoplay without a user gesture — this click IS the gesture. ---------- */
  var musicBtn = document.getElementById('music-toggle');
  var audioEl = document.getElementById('site-audio');
  if (musicBtn && audioEl) {
    musicBtn.addEventListener('click', function () {
      if (audioEl.paused) {
        audioEl.volume = 0.5;
        audioEl.play().catch(function () { /* ignore — some browsers still refuse, that's fine */ });
        musicBtn.classList.add('playing');
        musicBtn.setAttribute('aria-pressed', 'true');
      } else {
        audioEl.pause();
        musicBtn.classList.remove('playing');
        musicBtn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  /* ---------- scroll reveals: clip-path + fade + rise, staggered ---------- */
  var revealGroups = document.querySelectorAll('.product-grid, .collection-grid');
  revealGroups.forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      child.style.setProperty('--reveal-delay', i);
    });
  });

  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    if (!('IntersectionObserver' in window)) {
      // No IO support at all — show everything immediately rather than
      // leaving it clipped and invisible forever.
      revealEls.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });

      // Safety net: if the observer never fires for an element for any
      // reason (constrained embed contexts, unusual browser states), don't
      // leave real content permanently invisible — reveal what's left after
      // a few seconds regardless.
      setTimeout(function () {
        revealEls.forEach(function (el) { el.classList.add('in'); });
      }, 4000);
    }
  }

  /* ---------- magnetic buttons: nudge toward the pointer, spring back ----------
     Distinct, intentional interaction layer — not a cursor replacement. */
  document.querySelectorAll('.btn-magnetic').forEach(function (btn) {
    btn.addEventListener('mousemove', function (e) {
      if (btn.disabled) return;
      var rect = btn.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = 'translate(' + (x * 0.12).toFixed(1) + 'px, ' + (y * 0.3).toFixed(1) + 'px)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.transform = 'translate(0, 0)';
    });
  });

  /* product-card hover (images + video) now lives in ak-shop.js (delegated, works after Load more) */

  /* ---------- campaign drag-to-scroll (homepage) ---------- */
  var track = document.getElementById('campaign-track');
  if (track) {
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function (e) {
      isDown = true; track.classList.add('dragging');
      startX = e.pageX; scrollLeft = track.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      isDown = false; track.classList.remove('dragging');
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = scrollLeft - (e.pageX - startX);
    });
  }

  /* ---------- easter egg system: 3 of 4 entry points live in JS ----------
     4th entry point (direct URL /pages/art) needs no JS — it's just a page.
  ---------------------------------------------------------------------- */
  function unlockArt() {
    window.location.href = '/pages/art';
  }

  // method: click logo x7, 500ms reset window
  var logo = document.getElementById('logo-click');
  if (logo) {
    var clickCount = 0, clickTimer = null;
    logo.addEventListener('click', function (e) {
      e.preventDefault();
      clickCount++;
      clearTimeout(clickTimer);
      if (clickCount >= 7) { clickCount = 0; unlockArt(); return; }
      // one or a few clicks -> go home once the 7-click window passes
      clickTimer = setTimeout(function () {
        clickCount = 0;
        var home = logo.getAttribute('href') || '/';
        if (window.location.pathname === home) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        else { window.location.href = home; }
      }, 380);
    });
  }

  // method: konami code
  var konami = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
  var konamiPos = 0;
  window.addEventListener('keydown', function (e) {
    if (e.key === konami[konamiPos]) {
      konamiPos++;
      if (konamiPos === konami.length) { konamiPos = 0; unlockArt(); }
    } else {
      konamiPos = (e.key === konami[0]) ? 1 : 0;
    }
  });

  // method: hidden footer glyph
  var glyph = document.getElementById('hidden-glyph');
  if (glyph) {
    glyph.addEventListener('click', function (e) { e.preventDefault(); unlockArt(); });
  }

  /* ---------- cart drawer wiring ---------- */
  AK.cart.init();

});

/* ==========================================================================
   CART DRAWER — real Shopify AJAX Cart API (/cart/add.js, /cart/change.js,
   /cart.js). No page reload. Referenced pattern: mowalola.com's cart drawer
   (confirmed live — slide-out panel, TOTAL, GO TO CHECKOUT, CONTINUE SHOPPING).
   ========================================================================== */
AK.cart = (function () {
  var drawer, itemsEl, totalEl, countEls;
  var currentCurrency = 'USD';

  function moneyFormat(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currentCurrency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currentCurrency;
    }
  }

  function render(cart) {
    currentCurrency = cart.currency || currentCurrency;
    countEls.forEach(function (el) { el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : ''; });
    totalEl.textContent = moneyFormat(cart.total_price);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer-empty">Your cart is empty.</div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      return (
        '<div class="cart-line" data-key="' + item.key + '">' +
          '<img src="' + (item.image || '') + '" alt="" width="64" height="85">' +
          '<div class="cart-line-info">' +
            '<div class="cart-line-title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cart-line-variant">' + item.variant_title + '</div>' : '') +
            '<div class="cart-line-qty">' +
              '<button type="button" data-action="decrease">–</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-action="increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-line-price">' + moneyFormat(item.final_line_price) + '</div>' +
          '<button type="button" class="cart-line-remove" data-action="remove">Remove</button>' +
        '</div>'
      );
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function refresh() {
    return fetchCart().then(render);
  }

  function open() {
    drawer.classList.add('open');
  }

  function close() {
    drawer.classList.remove('open');
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    })
    .then(function () { return refresh(); })
    .then(function () { open(); });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(render);
  }

  function init() {
    drawer = document.getElementById('cart-drawer');
    if (!drawer) return; // theme.liquid not rendered (shouldn't happen, but be safe)

    itemsEl = document.getElementById('cart-drawer-items');
    totalEl = document.getElementById('cart-drawer-total');
    countEls = Array.prototype.slice.call(document.querySelectorAll('.cart-count'));

    document.getElementById('cart-drawer-overlay').addEventListener('click', close);
    document.getElementById('cart-drawer-close').addEventListener('click', close);

    var cartLink = document.getElementById('cart-icon-link');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        refresh().then(open);
      });
    }

    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-action]');
      if (!btn) return;
      var line = btn.closest('.cart-line');
      var key = line.dataset.key;
      var qtyEl = line.querySelector('.cart-line-qty span');
      var qty = parseInt(qtyEl.textContent, 10);

      if (btn.dataset.action === 'increase') changeLine(key, qty + 1);
      if (btn.dataset.action === 'decrease') changeLine(key, Math.max(0, qty - 1));
      if (btn.dataset.action === 'remove') changeLine(key, 0);
    });
  }

  return { init: init, addToCart: addToCart, refresh: refresh, open: open, close: close };
})();

/* ---------- password / loading screen (layout/password.liquid only) ---------- */
function akInitPasswordScreen() {
  var enterLink = document.getElementById('pw-enter-link');
  var formWrap = document.getElementById('pw-form-wrap');

  if (enterLink && formWrap) {
    enterLink.addEventListener('click', function (e) {
      e.preventDefault();
      formWrap.classList.add('open');
    });
  }

  var typeInstead = document.getElementById('pw-typeinstead');
  if (typeInstead && formWrap) {
    typeInstead.addEventListener('click', function () {
      formWrap.classList.add('show-manual');
      var input = formWrap.querySelector('input[type="password"]');
      if (input) input.focus();
    });
  }

  initPasswordPuzzle();

  var countdownEl = document.getElementById('countdown');
  if (countdownEl) {
    // TARGET_DATE now comes from Theme settings > Countdown (settings.countdown_target),
    // rendered into data-target by layout/password.liquid.
    var TARGET_DATE = new Date(countdownEl.dataset.target).getTime();

    function tick() {
      var now = Date.now();
      var diff = Math.max(0, TARGET_DATE - now);
      var d = Math.floor(diff / 86400000); diff -= d * 86400000;
      var h = Math.floor(diff / 3600000); diff -= h * 3600000;
      var m = Math.floor(diff / 60000); diff -= m * 60000;
      var s = Math.floor(diff / 1000);

      var elD = document.getElementById('cd-days');
      var elH = document.getElementById('cd-hours');
      var elM = document.getElementById('cd-mins');
      var elS = document.getElementById('cd-secs');
      if (elD) elD.textContent = String(d).padStart(2, '0');
      if (elH) elH.textContent = String(h).padStart(2, '0');
      if (elM) elM.textContent = String(m).padStart(2, '0');
      if (elS) elS.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  }
}
document.addEventListener('DOMContentLoaded', akInitPasswordScreen);

/* ---------- password puzzle: scattered letters, click into slots ----------
   Solving it spells out the real Shopify store password (see comment at
   the top of layout/password.liquid) and auto-submits the real form.
   Requires the merchant's actual store password to equal PUZZLE_WORD. */
function initPasswordPuzzle() {
  var PUZZLE_WORD = 'ANAMKARA';
  var puzzle = document.getElementById('pw-puzzle');
  var slotsEl = document.getElementById('pw-puzzle-slots');
  var tilesEl = document.getElementById('pw-puzzle-tiles');
  if (!puzzle || !slotsEl || !tilesEl) return;

  var letters = PUZZLE_WORD.split('');
  var filledCount = 0;

  letters.forEach(function (_, i) {
    var slot = document.createElement('div');
    slot.className = 'pw-slot';
    slot.dataset.index = i;
    slotsEl.appendChild(slot);
  });

  var order = letters.map(function (letter, id) { return { letter: letter, id: id }; });
  for (var i = order.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = order[i]; order[i] = order[j]; order[j] = tmp;
  }

  order.forEach(function (item, idx) {
    var tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'pw-tile';
    tile.textContent = item.letter;
    tile.dataset.uid = 'tile-' + item.id;

    // zone-based scatter: split the tile area into a 4x2 grid, one tile per
    // zone with jitter inside it — guarantees spread, never clusters/overlaps.
    var cols = 4, rows = 2;
    var col = idx % cols, row = Math.floor(idx / cols);
    var cellW = 100 / cols, cellH = 100 / rows;
    var jitterX = (Math.random() - 0.5) * (cellW * 0.5);
    var jitterY = (Math.random() - 0.5) * (cellH * 0.5);
    var x = (col + 0.5) * cellW + jitterX;
    var y = (row + 0.5) * cellH + jitterY;
    x = Math.max(6, Math.min(94, x));
    y = Math.max(10, Math.min(90, y));
    tile.style.left = x + '%';
    tile.style.top = y + '%';
    tile.style.transform = 'translate(-50%, -50%) rotate(' + (Math.random() * 36 - 18) + 'deg)';

    tile.addEventListener('click', function () {
      if (tile.classList.contains('placed')) return;
      var nextSlot = slotsEl.querySelector('.pw-slot:not(.filled)');
      if (!nextSlot) return;
      nextSlot.textContent = item.letter;
      nextSlot.classList.add('filled');
      nextSlot.dataset.tileRef = tile.dataset.uid;
      tile.classList.add('placed');
      tile.style.opacity = '0';
      tile.style.pointerEvents = 'none';
      filledCount++;
      if (filledCount === letters.length) checkPuzzle();
    });

    tilesEl.appendChild(tile);
  });

  slotsEl.addEventListener('click', function (e) {
    var slot = e.target.closest('.pw-slot.filled');
    if (!slot) return;
    var uid = slot.dataset.tileRef;
    var tile = tilesEl.querySelector('[data-uid="' + uid + '"]');
    if (tile) {
      tile.classList.remove('placed');
      tile.style.opacity = '1';
      tile.style.pointerEvents = 'auto';
    }
    slot.textContent = '';
    slot.classList.remove('filled');
    delete slot.dataset.tileRef;
    filledCount--;
  });

  function checkPuzzle() {
    var assembled = Array.prototype.map.call(slotsEl.querySelectorAll('.pw-slot'), function (s) {
      return s.textContent;
    }).join('');

    if (assembled === PUZZLE_WORD) {
      puzzle.classList.add('solved');
      setTimeout(function () {
        var pwInput = document.getElementById('password');
        var form = pwInput ? pwInput.closest('form') : null;
        if (pwInput) pwInput.value = PUZZLE_WORD;
        if (form) form.submit();
      }, 700);
    } else {
      puzzle.classList.add('shake');
      setTimeout(function () {
        puzzle.classList.remove('shake');
        slotsEl.querySelectorAll('.pw-slot').forEach(function (s) {
          s.textContent = '';
          s.classList.remove('filled');
          delete s.dataset.tileRef;
        });
        tilesEl.querySelectorAll('.pw-tile').forEach(function (t) {
          t.classList.remove('placed');
          t.style.opacity = '1';
          t.style.pointerEvents = 'auto';
        });
        filledCount = 0;
      }, 900);
    }
  }
}


/* ---------- header mobile menu + lookbook filter/viewer (Checkpoint D2) ---------- */
(function () {
  var hdr = document.getElementById('site-header');
  var tog = document.getElementById('nav-toggle');
  if (hdr && tog) {
    tog.addEventListener('click', function () {
      var open = hdr.classList.toggle('nav-open');
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      tog.textContent = open ? 'Close' : 'Menu';
    });
    hdr.querySelectorAll('.site-nav a').forEach(function (a) {
      a.addEventListener('click', function () { hdr.classList.remove('nav-open'); tog.setAttribute('aria-expanded', 'false'); tog.textContent = 'Menu'; });
    });
  }

  var chips = document.getElementById('lb-chips');
  var grid = document.getElementById('lb-grid');
  if (chips && grid) {
    chips.addEventListener('click', function (e) {
      var c = e.target.closest('.lb-chip'); if (!c) return;
      var f = c.getAttribute('data-filter');
      chips.querySelectorAll('.lb-chip').forEach(function (x) { x.classList.toggle('is-on', x === c); });
      grid.querySelectorAll('.lb-tile').forEach(function (t) {
        t.classList.toggle('is-hidden', f !== 'all' && t.getAttribute('data-cat') !== f);
      });
    });
    var viewer = document.getElementById('lb-viewer');
    var vimg = document.getElementById('lb-viewer-img');
    var vcap = document.getElementById('lb-viewer-cap');
    var close = function () { viewer.classList.remove('open'); viewer.setAttribute('aria-hidden', 'true'); };
    grid.addEventListener('click', function (e) {
      var t = e.target.closest('.lb-tile'); if (!t || !viewer) return;
      vimg.src = t.getAttribute('data-full'); vimg.alt = t.getAttribute('data-cap') || '';
      vcap.textContent = t.getAttribute('data-cap') || '';
      viewer.classList.add('open'); viewer.setAttribute('aria-hidden', 'false');
    });
    if (viewer) {
      viewer.querySelectorAll('[data-lb-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }
})();
